export { default } from './archive-pagination.js'
